<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <p class="small text-muted">Items marked with <span class="text-danger">*</span> require a response.</p>

        <h6 class="text-muted text-uppercase small mb-2">Permit</h6>
        <div class="row">
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="issuedDateTime">Date Permit was Issued <span class="text-danger">*</span></label>
                    <wj-input-date-time
                        [(ngModel)]="target.issuedDateTime"
                        name="issuedDateTime"
                        id="issuedDateTime"
                        [isRequired]="true"
                    ></wj-input-date-time>
                </div>
            </div>
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="expirationDateTime">Expiration Date &amp; Time</label>
                    <wj-input-date-time
                        [(ngModel)]="target.expirationDateTime"
                        name="expirationDateTime"
                        id="expirationDateTime"
                        [isRequired]="false"
                    ></wj-input-date-time>
                </div>
            </div>
        </div>
        <div class="row mb-2">
            <div class="col-12">
                <div class="form-check">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        id="checklistComplete"
                        name="checklistComplete"
                        [(ngModel)]="target.checklistComplete"
                        required
                    />
                    <label class="form-check-label" for="checklistComplete">
                        Checklist complete (Tripod, Harnesses, 4 Gas Monitor, Completed Permit, Top Attendant, Ventilation,
                        Taglines, Lighting) <span class="text-danger">*</span>
                    </label>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="job">Job Number and Name <span class="text-danger">*</span></label>
                    <wj-combo-box
                        [(ngModel)]="target.job"
                        name="job"
                        id="job"
                        [itemsSource]="jobList"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isRequired]="true"
                    ></wj-combo-box>
                </div>
            </div>
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="address">Address <span class="text-danger">*</span></label>
                    <app-voice-text-field
                        [(ngModel)]="target.address"
                        name="address"
                        inputId="address"
                        [rows]="2"
                        [showLocationButton]="true"
                    ></app-voice-text-field>
                    <input type="hidden" name="addressRequired" [ngModel]="target.address" required />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="jobSiteSpaceId">Job Site# / Space I.D.</label>
                    <input
                        type="text"
                        class="form-control"
                        id="jobSiteSpaceId"
                        name="jobSiteSpaceId"
                        [(ngModel)]="target.jobSiteSpaceId"
                    />
                </div>
            </div>
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="jobSupervisor">Job Supervisor</label>
                    <input
                        type="text"
                        class="form-control"
                        id="jobSupervisor"
                        name="jobSupervisor"
                        [(ngModel)]="target.jobSupervisor"
                    />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="workToBePerformed">Work to be Performed</label>
                    <app-voice-text-field
                        [(ngModel)]="target.workToBePerformed"
                        name="workToBePerformed"
                        inputId="workToBePerformed"
                        [rows]="2"
                    ></app-voice-text-field>
                </div>
            </div>
        </div>

        <h6 class="text-muted text-uppercase small mb-2 mt-3">Personnel &amp; Training</h6>
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="entrantNames">Entrants Names</label>
                    <app-voice-text-field
                        [(ngModel)]="target.entrantNames"
                        name="entrantNames"
                        inputId="entrantNames"
                        [rows]="2"
                    ></app-voice-text-field>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="attendantPersonnel">Attendant Personnel</label>
                    <app-voice-text-field
                        [(ngModel)]="target.attendantPersonnel"
                        name="attendantPersonnel"
                        inputId="attendantPersonnel"
                        [rows]="2"
                    ></app-voice-text-field>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="supervisorsName">Supervisor's Name</label>
                    <input
                        type="text"
                        class="form-control"
                        id="supervisorsName"
                        name="supervisorsName"
                        [(ngModel)]="target.supervisorsName"
                    />
                </div>
            </div>
        </div>
        <div class="row mb-2">
            <div class="col-md-4">
                <div class="form-check">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        id="entrantHasReceivedTraining"
                        name="entrantHasReceivedTraining"
                        [(ngModel)]="target.entrantHasReceivedTraining"
                    />
                    <label class="form-check-label" for="entrantHasReceivedTraining">Entrant has received training</label>
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-check">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        id="attendantHasReceivedTraining"
                        name="attendantHasReceivedTraining"
                        [(ngModel)]="target.attendantHasReceivedTraining"
                    />
                    <label class="form-check-label" for="attendantHasReceivedTraining">Attendant has received training</label>
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-check">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        id="supervisorHasReceivedTraining"
                        name="supervisorHasReceivedTraining"
                        [(ngModel)]="target.supervisorHasReceivedTraining"
                    />
                    <label class="form-check-label" for="supervisorHasReceivedTraining">Supervisor has received training</label>
                </div>
            </div>
        </div>

        <h6 class="text-muted text-uppercase small mb-2 mt-3">Initial Atmospheric Checks</h6>
        <div class="row">
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="initialOxygenLevel">Oxygen Level</label>
                    <input
                        type="text"
                        class="form-control"
                        id="initialOxygenLevel"
                        name="initialOxygenLevel"
                        [(ngModel)]="target.initialOxygenLevel"
                    />
                </div>
            </div>
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="initialFlammableLevel">Flammable gas, vapor or mist level</label>
                    <input
                        type="text"
                        class="form-control"
                        id="initialFlammableLevel"
                        name="initialFlammableLevel"
                        [(ngModel)]="target.initialFlammableLevel"
                    />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="initialDustLevel">Airborne combustible dust level</label>
                    <input
                        type="text"
                        class="form-control"
                        id="initialDustLevel"
                        name="initialDustLevel"
                        [(ngModel)]="target.initialDustLevel"
                    />
                </div>
            </div>
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="initialToxicLevel">Other toxic and hazardous substance level</label>
                    <input
                        type="text"
                        class="form-control"
                        id="initialToxicLevel"
                        name="initialToxicLevel"
                        [(ngModel)]="target.initialToxicLevel"
                    />
                </div>
            </div>
        </div>
        <div class="row mb-2">
            <div class="col-md-6">
                <div class="form-check">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        id="initialOxygenSafe"
                        name="initialOxygenSafe"
                        [(ngModel)]="target.initialOxygenSafe"
                    />
                    <label class="form-check-label" for="initialOxygenSafe"
                        >Oxygen levels are safe (neither above 23.5% nor below 19.5%)</label
                    >
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-check">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        id="initialFlammableSafe"
                        name="initialFlammableSafe"
                        [(ngModel)]="target.initialFlammableSafe"
                    />
                    <label class="form-check-label" for="initialFlammableSafe"
                        >Flammable levels are safe (not over 10% of LFL)</label
                    >
                </div>
            </div>
        </div>
        <div class="row mb-2">
            <div class="col-md-6">
                <div class="form-check">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        id="initialDustSafe"
                        name="initialDustSafe"
                        [(ngModel)]="target.initialDustSafe"
                    />
                    <label class="form-check-label" for="initialDustSafe"
                        >Airborne combustible dust levels are safe (do not meet or exceed LFL)</label
                    >
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-check">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        id="initialToxicSafe"
                        name="initialToxicSafe"
                        [(ngModel)]="target.initialToxicSafe"
                    />
                    <label class="form-check-label" for="initialToxicSafe"
                        >Other toxic levels are safe (do not exceed PEL)</label
                    >
                </div>
            </div>
        </div>
        <div class="row mb-2">
            <div class="col-12">
                <div class="form-check">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        id="initialOtherConditionsSafe"
                        name="initialOtherConditionsSafe"
                        [(ngModel)]="target.initialOtherConditionsSafe"
                    />
                    <label class="form-check-label" for="initialOtherConditionsSafe"
                        >Other atmospheric conditions are safe (no IDLH condition)</label
                    >
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="initialUnsafeDescription">If No, describe</label>
                    <app-voice-text-field
                        [(ngModel)]="target.initialUnsafeDescription"
                        name="initialUnsafeDescription"
                        inputId="initialUnsafeDescription"
                        [rows]="2"
                    ></app-voice-text-field>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-4 col-12">
                <div class="form-group">
                    <label for="initialTesterName">Tester's Name</label>
                    <input
                        type="text"
                        class="form-control"
                        id="initialTesterName"
                        name="initialTesterName"
                        [(ngModel)]="target.initialTesterName"
                    />
                </div>
            </div>
            <div class="col-sm-4 col-12">
                <div class="form-group">
                    <label for="initialTestedOn">Date &amp; Time of Testing</label>
                    <wj-input-date-time
                        [(ngModel)]="target.initialTestedOn"
                        name="initialTestedOn"
                        id="initialTestedOn"
                        [isRequired]="false"
                    ></wj-input-date-time>
                </div>
            </div>
            <div class="col-sm-4 col-12">
                <div class="form-group">
                    <label for="initialTesterSignature">Tester's Signature</label>
                    <input
                        type="text"
                        class="form-control"
                        id="initialTesterSignature"
                        name="initialTesterSignature"
                        [(ngModel)]="target.initialTesterSignature"
                    />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-4 col-12">
                <div class="form-group">
                    <label for="initialTesterSignedOn">Tester Signed On</label>
                    <wj-input-date-time
                        [(ngModel)]="target.initialTesterSignedOn"
                        name="initialTesterSignedOn"
                        id="initialTesterSignedOn"
                        [isRequired]="false"
                    ></wj-input-date-time>
                </div>
            </div>
        </div>

        <div class="d-flex align-items-center justify-content-between mb-2 mt-3">
            <h6 class="text-muted text-uppercase small mb-0">Space Preparation (Blanking, Lockout, Tagout, etc.)</h6>
            <button type="button" class="btn btn-sm btn-outline-primary" (click)="addPrepHazard()">
                <fa-icon [icon]="faPlus"></fa-icon> Add Hazard
            </button>
        </div>
        @if (target.prepHazards.length === 0) {
            <p class="text-muted small">No space-prep hazards added.</p>
        }
        @for (row of target.prepHazards; track row.id; let i = $index) {
            <div class="card mb-2">
                <div class="card-body py-2">
                    <div class="d-flex justify-content-between align-items-center mb-2">
                        <strong class="small">Hazard {{ i + 1 }}</strong>
                        <button type="button" class="btn btn-sm btn-outline-danger" (click)="removePrepHazard(i)">
                            <fa-icon [icon]="faTrash"></fa-icon>
                        </button>
                    </div>
                    <div class="row">
                        <div class="col-md-4 form-group mb-2">
                            <label [for]="'prepHazard_' + i">Hazard</label>
                            <app-voice-text-field
                                [(ngModel)]="row.hazard"
                                [name]="'prepHazard_' + i"
                                [inputId]="'prepHazard_' + i"
                                [rows]="2"
                            ></app-voice-text-field>
                        </div>
                        <div class="col-md-5 form-group mb-2">
                            <label [for]="'prepIsolation_' + i">Preparation / Isolation</label>
                            <app-voice-text-field
                                [(ngModel)]="row.preparationIsolation"
                                [name]="'prepIsolation_' + i"
                                [inputId]="'prepIsolation_' + i"
                                [rows]="2"
                            ></app-voice-text-field>
                        </div>
                        <div class="col-md-3 form-group mb-2">
                            <label [for]="'prepDate_' + i">Date Completed</label>
                            <wj-input-date
                                [id]="'prepDate_' + i"
                                [name]="'prepDate_' + i"
                                [(ngModel)]="row.dateCompleted"
                                [isRequired]="false"
                            ></wj-input-date>
                        </div>
                    </div>
                </div>
            </div>
        }

        <h6 class="text-muted text-uppercase small mb-2 mt-3">Ventilation</h6>
        <div class="row mb-2">
            <div class="col-md-6">
                <div class="form-check">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        id="mechanicalVentilation"
                        name="mechanicalVentilation"
                        [(ngModel)]="target.mechanicalVentilation"
                    />
                    <label class="form-check-label" for="mechanicalVentilation">Mechanical</label>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-check">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        id="naturalVentilationOnly"
                        name="naturalVentilationOnly"
                        [(ngModel)]="target.naturalVentilationOnly"
                    />
                    <label class="form-check-label" for="naturalVentilationOnly">Natural ventilation only</label>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="ventilationMalfunctionDetection"
                        >Means of detecting an increase in atmospheric hazard levels if the ventilation system malfunctions</label
                    >
                    <app-voice-text-field
                        [(ngModel)]="target.ventilationMalfunctionDetection"
                        name="ventilationMalfunctionDetection"
                        inputId="ventilationMalfunctionDetection"
                        [rows]="2"
                    ></app-voice-text-field>
                </div>
            </div>
        </div>

        <h6 class="text-muted text-uppercase small mb-2 mt-3">Atmospheric Checks After Isolation and Ventilation</h6>
        <div class="row">
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="postOxygenLevel">Oxygen Level</label>
                    <input
                        type="text"
                        class="form-control"
                        id="postOxygenLevel"
                        name="postOxygenLevel"
                        [(ngModel)]="target.postOxygenLevel"
                    />
                </div>
            </div>
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="postFlammableLevel">Flammable gas, vapor or mist level</label>
                    <input
                        type="text"
                        class="form-control"
                        id="postFlammableLevel"
                        name="postFlammableLevel"
                        [(ngModel)]="target.postFlammableLevel"
                    />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="postDustLevel">Airborne combustible dust level</label>
                    <input
                        type="text"
                        class="form-control"
                        id="postDustLevel"
                        name="postDustLevel"
                        [(ngModel)]="target.postDustLevel"
                    />
                </div>
            </div>
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="postToxicLevel">Other toxic and hazardous substance level</label>
                    <input
                        type="text"
                        class="form-control"
                        id="postToxicLevel"
                        name="postToxicLevel"
                        [(ngModel)]="target.postToxicLevel"
                    />
                </div>
            </div>
        </div>
        <div class="row mb-2">
            <div class="col-md-6">
                <div class="form-check">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        id="postOxygenSafe"
                        name="postOxygenSafe"
                        [(ngModel)]="target.postOxygenSafe"
                    />
                    <label class="form-check-label" for="postOxygenSafe"
                        >Oxygen levels are safe (neither above 23.5% nor below 19.5%)</label
                    >
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-check">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        id="postFlammableSafe"
                        name="postFlammableSafe"
                        [(ngModel)]="target.postFlammableSafe"
                    />
                    <label class="form-check-label" for="postFlammableSafe"
                        >Flammable levels are safe (not over 10% of LFL)</label
                    >
                </div>
            </div>
        </div>
        <div class="row mb-2">
            <div class="col-md-6">
                <div class="form-check">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        id="postDustSafe"
                        name="postDustSafe"
                        [(ngModel)]="target.postDustSafe"
                    />
                    <label class="form-check-label" for="postDustSafe"
                        >Airborne combustible dust levels are safe (do not meet or exceed LFL)</label
                    >
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-check">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        id="postToxicSafe"
                        name="postToxicSafe"
                        [(ngModel)]="target.postToxicSafe"
                    />
                    <label class="form-check-label" for="postToxicSafe"
                        >Other toxic levels are safe (do not exceed PEL)</label
                    >
                </div>
            </div>
        </div>
        <div class="row mb-2">
            <div class="col-12">
                <div class="form-check">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        id="postOtherConditionsSafe"
                        name="postOtherConditionsSafe"
                        [(ngModel)]="target.postOtherConditionsSafe"
                    />
                    <label class="form-check-label" for="postOtherConditionsSafe"
                        >Other atmospheric conditions are safe (no IDLH condition)</label
                    >
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="postUnsafeDescription">If No, describe</label>
                    <app-voice-text-field
                        [(ngModel)]="target.postUnsafeDescription"
                        name="postUnsafeDescription"
                        inputId="postUnsafeDescription"
                        [rows]="2"
                    ></app-voice-text-field>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-4 col-12">
                <div class="form-group">
                    <label for="postTesterName">Tester's Name</label>
                    <input
                        type="text"
                        class="form-control"
                        id="postTesterName"
                        name="postTesterName"
                        [(ngModel)]="target.postTesterName"
                    />
                </div>
            </div>
            <div class="col-sm-4 col-12">
                <div class="form-group">
                    <label for="postTestedOn">Date &amp; Time of Testing</label>
                    <wj-input-date-time
                        [(ngModel)]="target.postTestedOn"
                        name="postTestedOn"
                        id="postTestedOn"
                        [isRequired]="false"
                    ></wj-input-date-time>
                </div>
            </div>
            <div class="col-sm-4 col-12">
                <div class="form-group">
                    <label for="postTesterSignature">Tester's Signature</label>
                    <input
                        type="text"
                        class="form-control"
                        id="postTesterSignature"
                        name="postTesterSignature"
                        [(ngModel)]="target.postTesterSignature"
                    />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-4 col-12">
                <div class="form-group">
                    <label for="postTesterSignedOn">Tester Signed On</label>
                    <wj-input-date-time
                        [(ngModel)]="target.postTesterSignedOn"
                        name="postTesterSignedOn"
                        id="postTesterSignedOn"
                        [isRequired]="false"
                    ></wj-input-date-time>
                </div>
            </div>
        </div>

        <h6 class="text-muted text-uppercase small mb-2 mt-3">Communication &amp; Rescue</h6>
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="communicationProcedures">Communication Procedures (Radios, Yelling)</label>
                    <app-voice-text-field
                        [(ngModel)]="target.communicationProcedures"
                        name="communicationProcedures"
                        inputId="communicationProcedures"
                        [rows]="2"
                    ></app-voice-text-field>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="rescueTeamContactProcedure"
                        >Rescue Team Contact Procedure (Self Rescue, Assisted, Recovery Call 911)</label
                    >
                    <app-voice-text-field
                        [(ngModel)]="target.rescueTeamContactProcedure"
                        name="rescueTeamContactProcedure"
                        inputId="rescueTeamContactProcedure"
                        [rows]="2"
                    ></app-voice-text-field>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="procedureReviewedBy">Procedure Reviewed By</label>
                    <input
                        type="text"
                        class="form-control"
                        id="procedureReviewedBy"
                        name="procedureReviewedBy"
                        [(ngModel)]="target.procedureReviewedBy"
                    />
                </div>
            </div>
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="procedureReviewedOn">Review Date</label>
                    <wj-input-date
                        [(ngModel)]="target.procedureReviewedOn"
                        name="procedureReviewedOn"
                        id="procedureReviewedOn"
                        [isRequired]="false"
                    ></wj-input-date>
                </div>
            </div>
        </div>

        <h6 class="text-muted text-uppercase small mb-2 mt-3">Equipment Check (Available and Functional)</h6>
        <div class="row mb-2">
            <div class="col-md-6">
                <div class="form-check">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        id="equipmentFourGasMonitor"
                        name="equipmentFourGasMonitor"
                        [(ngModel)]="target.equipmentFourGasMonitor"
                    />
                    <label class="form-check-label" for="equipmentFourGasMonitor">Direct reading, calibrated 4 Gas Monitor</label>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-check">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        id="equipmentVentilation"
                        name="equipmentVentilation"
                        [(ngModel)]="target.equipmentVentilation"
                    />
                    <label class="form-check-label" for="equipmentVentilation">Ventilation Equipment</label>
                </div>
            </div>
        </div>
        <div class="row mb-2">
            <div class="col-md-6">
                <div class="form-check">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        id="equipmentHarnessLifelines"
                        name="equipmentHarnessLifelines"
                        [(ngModel)]="target.equipmentHarnessLifelines"
                    />
                    <label class="form-check-label" for="equipmentHarnessLifelines"
                        >Safety harness and lifelines for entry personnel</label
                    >
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-check">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        id="equipmentRetrievalDevice"
                        name="equipmentRetrievalDevice"
                        [(ngModel)]="target.equipmentRetrievalDevice"
                    />
                    <label class="form-check-label" for="equipmentRetrievalDevice">Retrieval device (Harness, Tripod)</label>
                </div>
            </div>
        </div>
        <div class="row mb-2">
            <div class="col-md-6">
                <div class="form-check">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        id="equipmentCommunications"
                        name="equipmentCommunications"
                        [(ngModel)]="target.equipmentCommunications"
                    />
                    <label class="form-check-label" for="equipmentCommunications">Communications (Hand Held Radios, Yelling)</label>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-check">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        id="equipmentAccess"
                        name="equipmentAccess"
                        [(ngModel)]="target.equipmentAccess"
                    />
                    <label class="form-check-label" for="equipmentAccess">Access Equipment (Ladder, Steps)</label>
                </div>
            </div>
        </div>
        <div class="row mb-2">
            <div class="col-md-6">
                <div class="form-check">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        id="equipmentProtectiveClothing"
                        name="equipmentProtectiveClothing"
                        [(ngModel)]="target.equipmentProtectiveClothing"
                    />
                    <label class="form-check-label" for="equipmentProtectiveClothing"
                        >Protective Clothing/Equipment (SAR Unit, SCBA)</label
                    >
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-check">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        id="equipmentElectricListed"
                        name="equipmentElectricListed"
                        [(ngModel)]="target.equipmentElectricListed"
                    />
                    <label class="form-check-label" for="equipmentElectricListed"
                        >All electric equipment listed for area classification</label
                    >
                </div>
            </div>
        </div>

        <div class="d-flex align-items-center justify-content-between mb-2 mt-3">
            <h6 class="text-muted text-uppercase small mb-0">Periodic Atmospheric Tests</h6>
            <button type="button" class="btn btn-sm btn-outline-primary" (click)="addPeriodicTest()">
                <fa-icon [icon]="faPlus"></fa-icon> Add Test
            </button>
        </div>
        @if (target.periodicTests.length === 0) {
            <p class="text-muted small">No periodic tests added.</p>
        }
        @for (row of target.periodicTests; track row.id; let i = $index) {
            <div class="card mb-2">
                <div class="card-body py-2">
                    <div class="d-flex justify-content-between align-items-center mb-2">
                        <strong class="small">Test {{ i + 1 }}</strong>
                        <button type="button" class="btn btn-sm btn-outline-danger" (click)="removePeriodicTest(i)">
                            <fa-icon [icon]="faTrash"></fa-icon>
                        </button>
                    </div>
                    <div class="row">
                        <div class="col-md-4 form-group mb-2">
                            <label [for]="'periodicTestedOn_' + i">Test Time</label>
                            <wj-input-date-time
                                [id]="'periodicTestedOn_' + i"
                                [name]="'periodicTestedOn_' + i"
                                [(ngModel)]="row.testedOn"
                                [isRequired]="false"
                            ></wj-input-date-time>
                        </div>
                        <div class="col-md-2 form-group mb-2">
                            <label [for]="'oxygenO2_' + i">Oxygen O2</label>
                            <input
                                type="text"
                                class="form-control"
                                [id]="'oxygenO2_' + i"
                                [name]="'oxygenO2_' + i"
                                [(ngModel)]="row.oxygenO2"
                            />
                        </div>
                        <div class="col-md-2 form-group mb-2">
                            <label [for]="'flammableLel_' + i">Flammable LEL</label>
                            <input
                                type="text"
                                class="form-control"
                                [id]="'flammableLel_' + i"
                                [name]="'flammableLel_' + i"
                                [(ngModel)]="row.flammableLel"
                            />
                        </div>
                        <div class="col-md-2 form-group mb-2">
                            <label [for]="'combustibleCo2_' + i">Combustible CO2</label>
                            <input
                                type="text"
                                class="form-control"
                                [id]="'combustibleCo2_' + i"
                                [name]="'combustibleCo2_' + i"
                                [(ngModel)]="row.combustibleCo2"
                            />
                        </div>
                        <div class="col-md-2 form-group mb-2">
                            <label [for]="'toxicH2s_' + i">Toxic H2S</label>
                            <input
                                type="text"
                                class="form-control"
                                [id]="'toxicH2s_' + i"
                                [name]="'toxicH2s_' + i"
                                [(ngModel)]="row.toxicH2s"
                            />
                        </div>
                    </div>
                </div>
            </div>
        }

        <h6 class="text-muted text-uppercase small mb-2 mt-3">Certification</h6>
        <p class="small text-muted">
            We have reviewed the work authorized by this permit and the information contained herein. Affected employees, entrants,
            attendants and supervisors have received and understand written instructions and safety procedures. Entry cannot be
            approved if any items are marked in the "No" column. This permit is valid only if all appropriate items are completed.
        </p>
        <div class="row">
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="preparerSignature">Permit Prepared by</label>
                    <input
                        type="text"
                        class="form-control"
                        id="preparerSignature"
                        name="preparerSignature"
                        [(ngModel)]="target.preparerSignature"
                    />
                </div>
            </div>
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="preparerSignedOn">Prepared On</label>
                    <wj-input-date-time
                        [(ngModel)]="target.preparerSignedOn"
                        name="preparerSignedOn"
                        id="preparerSignedOn"
                        [isRequired]="false"
                    ></wj-input-date-time>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-4 col-12">
                <div class="form-group">
                    <label for="entrySupervisorSignature">Entry Supervisor Signature</label>
                    <input
                        type="text"
                        class="form-control"
                        id="entrySupervisorSignature"
                        name="entrySupervisorSignature"
                        [(ngModel)]="target.entrySupervisorSignature"
                    />
                </div>
            </div>
            <div class="col-sm-4 col-12">
                <div class="form-group">
                    <label for="entrySupervisorPrintedName">Entry Supervisor Printed Name</label>
                    <input
                        type="text"
                        class="form-control"
                        id="entrySupervisorPrintedName"
                        name="entrySupervisorPrintedName"
                        [(ngModel)]="target.entrySupervisorPrintedName"
                    />
                </div>
            </div>
            <div class="col-sm-4 col-12">
                <div class="form-group">
                    <label for="entrySupervisorSignedOn">Date</label>
                    <wj-input-date-time
                        [(ngModel)]="target.entrySupervisorSignedOn"
                        name="entrySupervisorSignedOn"
                        id="entrySupervisorSignedOn"
                        [isRequired]="false"
                    ></wj-input-date-time>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-4 col-12">
                <div class="form-group">
                    <label for="entrantSignature">Entrant Signature</label>
                    <input
                        type="text"
                        class="form-control"
                        id="entrantSignature"
                        name="entrantSignature"
                        [(ngModel)]="target.entrantSignature"
                    />
                </div>
            </div>
            <div class="col-sm-4 col-12">
                <div class="form-group">
                    <label for="entrantPrintedName">Entrant Printed Name</label>
                    <input
                        type="text"
                        class="form-control"
                        id="entrantPrintedName"
                        name="entrantPrintedName"
                        [(ngModel)]="target.entrantPrintedName"
                    />
                </div>
            </div>
            <div class="col-sm-4 col-12">
                <div class="form-group">
                    <label for="entrantSignedOn">Entrant Date</label>
                    <wj-input-date-time
                        [(ngModel)]="target.entrantSignedOn"
                        name="entrantSignedOn"
                        id="entrantSignedOn"
                        [isRequired]="false"
                    ></wj-input-date-time>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-4 col-12">
                <div class="form-group">
                    <label for="attendantSignature">Attendant Signature</label>
                    <input
                        type="text"
                        class="form-control"
                        id="attendantSignature"
                        name="attendantSignature"
                        [(ngModel)]="target.attendantSignature"
                    />
                </div>
            </div>
            <div class="col-sm-4 col-12">
                <div class="form-group">
                    <label for="attendantPrintedName">Attendant Printed Name</label>
                    <input
                        type="text"
                        class="form-control"
                        id="attendantPrintedName"
                        name="attendantPrintedName"
                        [(ngModel)]="target.attendantPrintedName"
                    />
                </div>
            </div>
            <div class="col-sm-4 col-12">
                <div class="form-group">
                    <label for="attendantSignedOn">Attendant Date</label>
                    <wj-input-date-time
                        [(ngModel)]="target.attendantSignedOn"
                        name="attendantSignedOn"
                        id="attendantSignedOn"
                        [isRequired]="false"
                    ></wj-input-date-time>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
            } @else {
                <span>Save</span>
            }
        </button>
        <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
    </div>
</form>
